import React, { Component } from 'react';
import { Window } from '@progress/kendo-react-dialogs';
import { PDFViewer, PDFViewerTool } from '@progress/kendo-react-pdf-viewer';

interface DocumentViewerProps {
  content?: any;
  updatedContents?: any;
}

interface DocumentViewerState {
}

const tools: PDFViewerTool[] = [
  "pager",
  "spacer",
  "zoomInOut",
  "zoom",
  "spacer",
  "search",
];

class DocumentViewer extends Component<DocumentViewerProps, DocumentViewerState> {
  constructor(props: DocumentViewerProps) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('contextmenu', this.handleContextMenu);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('contextmenu', this.handleContextMenu);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && (event.key === 'a' || event.key === 'c')) {
      event.preventDefault();
    }
  };

  handleContextMenu = (event: Event) => {
    event.preventDefault();
  };

  render() {
    const { content, updatedContents } = this.props;

    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    return (
      <div>
        {content.fileUrl && (
          <Window
            title={content.title}
            onClose={() => updatedContents(null, null, content.id, content)}
            initialHeight={550}
            initialWidth={976.593}
            initialTop={currentScrollPosition + 20}
          >
            <div>
              {content.fileType === 'pdf' ? (
                <div className ="pdf-viewer-disabled-text-select">
                  <PDFViewer url={content.fileUrl} tools={tools} defaultZoom={1.5}/>
                </div>
              ) : content.fileType === 'image' ? (
                <div className="col-12 text-center">
                  <img
                    src={content.fileUrl}
                    width="100%"
                    height="auto"
                    onContextMenu={(e) => e.preventDefault()}
                    draggable={false}
                  />
                </div>
              ) : content.fileType === 'video' ? (
                <div className="col-12 text-center">
                  <video
                    controls
                    controlsList="nodownload"
                    onContextMenu={(e: React.MouseEvent<HTMLVideoElement, MouseEvent>) =>
                      e.preventDefault()
                    }
                    width="100%"
                    height="auto"
                  >
                    <source src={content.fileUrl} type={'video/mp4'} />
                  </video>
                </div>
              ) : (
                <div className="col-12 text-center" style={{ fontSize: '13px' }}>This type of document is not supported.</div>
              )}
            </div>
           </Window>
        )}
      </div>
    );
  }
}

export default DocumentViewer;